var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffiliate43A0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.76,
    height: 38.666,
    viewBox: "0 0 38.76 38.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.341,
    y1: 1,
    x2: 0.912,
    y2: -0.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8070e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#463d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_742",
    x: 5.699,
    y: 0,
    width: 27.426,
    height: 27.424,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.322
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.122,
    y1: 1,
    x2: 1,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_57",
    x: 0,
    y: 10.037,
    width: 38.76,
    height: 28.629,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.322
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(8.556 6.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0 3.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_742-2",
    "data-name": "Rectangle 742",
    d: "M11.828,3.044h0a3.8,3.8,0,0,1,3.8,3.8h0a3.8,3.8,0,0,1-3.8,3.8h0a3.8,3.8,0,0,1-3.8-3.8h0A3.8,3.8,0,0,1,11.828,3.044Z",
    transform: "translate(-3.182 -3.044)",
    fill: "#8875ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    d: "M2.963,20.589h0a8.619,8.619,0,0,1,8.62-8.618h0a8.619,8.619,0,0,1,8.62,8.618Z",
    transform: "translate(-2.963 -3.43)",
    fill: "#8875ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62-2",
    "data-name": "Group 62",
    transform: "translate(3.694)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.25, -6.25)",
    filter: "url(#Rectangle_742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_742-3",
    "data-name": "Rectangle 742",
    d: "M12.494,3.044h0a4.463,4.463,0,0,1,4.463,4.463h0a4.462,4.462,0,0,1-4.463,4.462h0A4.462,4.462,0,0,1,8.031,7.507h0A4.463,4.463,0,0,1,12.494,3.044Z",
    transform: "translate(9.92 3.21)",
    stroke: "rgba(204,214,246,0.5)",
    strokeWidth: 0.5,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.25, -6.25)",
    filter: "url(#Path_57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57-3",
    "data-name": "Path 57",
    d: "M2.963,22.1h0a10.129,10.129,0,0,1,10.13-10.129h0A10.13,10.13,0,0,1,23.223,22.1Z",
    transform: "translate(9.29 4.32)",
    stroke: "rgba(204,214,246,0.5)",
    strokeWidth: 0.5,
    fill: "url(#linear-gradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliate43A0);
export default __webpack_public_path__ + "static/media/affiliate43a0.0fcabbe908a9b58ff2f0b8c29b9c5a7a.svg";
export { ForwardRef as ReactComponent };